import { notification } from "antd";

import history from "../../routes/history";
import api from "../api";
import ApiException from "../exception/ApiException";
import moment from "moment";

const registerViagem = async (values) => {
  try {
    const normalized = normalizeViagem(values);
    console.log(values);
    await api.post("viagens", normalized);
    history.push("/viagens");
    notification.open({
      message: "Viagem adicionado com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const abrirComprovanteViagem = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}/viagens/comprovante/${id}`;
  window.open(url, "PRINT", "height=720,width=900");
};

const getViagem = async (id) => {
  try {
    const { data } = await api.get(`viagens/${id}`);
    const geted = onGetViagem(data);
    return geted;
  } catch (error) {
    console.log(error)
    throw new ApiException(error?.response?.data?.error);
  }
};

const deleteViagem = async (id) => {
  try {
    await api.delete(`viagens/${id}`);
    notification.open({
      message: "Viagem deletada com sucesso",
    });
  } catch (error) {
    notification.open({
      message: error.response.data.error,
    });
  }
};

const getViagens = async (page, filter = "", paginated = "") => {
  const { data: viagens } = await api.get(
    `viagens?page=${page}&filter=${filter}&paginated=${paginated}`
  );
  return viagens;
};

const updateViagem = async (viagem, values) => {
  try {
    const normalized = normalizeViagem(values);
    normalized.id = viagem.id;
    await api.put("viagens", normalized);
    history.push("/viagens");
    notification.open({
      message: "Viagem atualizada com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};
const finalizarViagem = async (id) => {
  try {
    await api.patch("viagens/finalizar/" + id);
    notification.open({
      message: "Viagem finalizada com sucesso!",
    });
    history.push("/viagens");
  } catch (error) {
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};
const cancelarViagem = async (id, motivo) => {
  try {
    await api.patch("viagens/cancelar/" + id, { motivo });
    notification.open({
      message: "Viagem cancelada com sucesso!",
    });
    history.push("/viagens");
  } catch (error) {
    console.log(error);
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

const normalizeViagem = (values) => {
  const normalized = { ...values };

  // Função auxiliar para parse seguro
  const getObjectId = (jsonString) => {
    if (!jsonString) return null;
    try {
      const obj = JSON.parse(jsonString);
      return obj?.id || null;
    } catch {
      return null;
    }
  };

  // Mapeia os campos
  normalized.paciente_id = getObjectId(values.paciente);
  normalized.veiculo_id = getObjectId(values.veiculo);
  normalized.motorista_id = getObjectId(values.motorista);

  normalized.local_origem_id = getObjectId(values.local_origem);
  normalized.local_destino_id = getObjectId(values.local_destino);

  // Formata datas
  const formatDateTime = (date, format) => {
    if (!date) return null;
    try {
      return moment(date).format(format);
    } catch {
      return date; // Retorna original se der erro
    }
  };

  normalized.data_saida = formatDateTime(values.data_saida, "YYYY-MM-DD HH:mm");
  normalized.horario_saida = formatDateTime(values.horario_saida, "HH:mm");

  // Campos opcionais
  if (values.horario_marcacao) {
    normalized.horario_marcacao = formatDateTime(
      values.horario_marcacao,
      "YYYY-MM-DD HH:mm"
    );
  }

  if (values.horario_estimado_chegada) {
    normalized.horario_estimado_chegada = formatDateTime(
      values.horario_estimado_chegada,
      "YYYY-MM-DD HH:mm"
    );
  }

  // Remove os campos que não devem ir para a API
  delete normalized.paciente;
  delete normalized.veiculo;
  delete normalized.motorista;
  delete normalized.local_embarque;
  delete normalized.local_desembarque;
  delete normalized.local_origem;
  delete normalized.local_destino;

  return normalized;
};


const onGetViagem = (values) => {
  if (!values) return {};
  
  const processed = { ...values };
  
  const processRelationField = (fieldName) => {
    const fieldValue = processed[fieldName];
    
    if (!fieldValue) {
      processed[fieldName] = null;
      return;
    }
    
    if (typeof fieldValue === 'string') {
      if (fieldValue === 'null' || fieldValue === '' || fieldValue === 'undefined') {
        processed[fieldName] = null;
      }
      return;
    }
    
    if (typeof fieldValue === 'object') {
      try {
        processed[fieldName] = JSON.stringify(fieldValue);
      } catch {
        processed[fieldName] = null;
      }
      return;
    }
    
    processed[fieldName] = null;
  };
  
  // Processa campos de relacionamento
  ['motorista', 'paciente', 'veiculo', 'local_destino', 'local_origem'].forEach(processRelationField);
  
  if (processed.data_saida) {
    processed.data_saida = moment(processed.data_saida);
  }
  
  ['horario_saida', 'horario_marcacao', 'horario_estimado_chegada'].forEach(field => {
    if (processed[field]) {
      processed[field] = moment(processed[field]);
    }
  });
  
  return processed;
};

export {
  registerViagem,
  deleteViagem,
  getViagem,
  getViagens,
  updateViagem,
  abrirComprovanteViagem,
  cancelarViagem,
  finalizarViagem,
};
